import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

const ConfirmationDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = '确定', 
  cancelText = '取消',
  showConfirmButton = true,
  showCancelButton = true, }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          backgroundColor: 'var(--bg-secondary-color)',
          color: '#fff',
          maxWidth: '320px',
          width: '80%',
          paddingBottom: 1,      

          '& .MuiDialogContent-root p':{
            color: '#fff',
            fontWeight: '300',
          }
        }
      }}
    >
      <DialogTitle variant="h5">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText variant="body2">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {/* Render Cancel Button if enabled */}
        {showCancelButton && (
          <Button onClick={onClose} variant="outlined" className="outline-button">
            {cancelText}
          </Button>
        )}
        {/* Render Confirm Button if enabled */}
        {showConfirmButton && (
          <Button onClick={onConfirm} variant="contained" className="primary-button">
            {confirmText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
